export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8787.2d2eecdf.jpg";